// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"tooltip_tooltipContainer__4ipUK","tooltipBox":"tooltip_tooltipBox__YnA4Z"};